import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { MdArrowBackIos } from "react-icons/md";

export default function DiscountDetailsHeaderMob() {
  const { t } = useTranslation();

  return (
    <Link to=".." className="flex items-center gap-1 text-font-minimal! hover:text-font-active!">
      <MdArrowBackIos className="rtl:-scale-x-100" />
      {t("UserHistory.common.back")}
    </Link>
  );
}
